<template>
  <label
    ref="$input"
    spellcheck="false"
    autocapitalize="false"
    autocomplete="off"
    :class="['bear-autocomplete', { 'bear-autocomplete-disabled': disabled }]">
    <el-popover ref="popover" placement="bottom-start" :popper-class="`bear-autocomplete-popper ${realItems.length ? '' : 'hide'}`" :width="200">
      <template #reference>
        <bear-input v-model.trim="value" @focus="tempValue = ''" :attrs="attrs" @input="setValue(value)"></bear-input>
      </template>
      <template #default>
        <ul class="bear-autocomplete-options">
          <li v-for="(obj, i) in realItems" :key="i" :class="{on: obj.Value === value}" @click="setValue(obj.Value, obj)">{{ obj.Value }}</li>
        </ul>
      </template>
    </el-popover>
  </label>
</template>
<script>
export default {
  name: "BearAutocomplete",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      value: "",
      tempValue: "",
      instance: null,
    };
  },
  computed: {
    realItems() {
      let { items, tempValue } = this;
      return tempValue
        ? items.filter((obj) => {
            return obj.Value.toLowerCase().indexOf(tempValue.toLowerCase()) >= 0;
          })
        : items;
    },
  },
  watch: {
    modelValue() {
      if (this.value !== this.modelValue) {
        this.value = this.modelValue;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.initItems();
    }, 1000);
  },
  methods: {
    initItems() {
      this.$emit("getAutoItems", (items) => {
        this.items = items;
      });
    },
    setValue(value, instance) {
      this.value = value;
      this.tempValue = value;
      this.instance = instance;
      this.input();
      if (this.options.OptionsFromStore && !this.items.length) this.initItems()
    },
    input() {
      this.$emit("update:modelValue", this.value);
      this.$emit("input", this.instance);
    },
  },
};
</script>
<style lang="scss">
.bear-autocomplete {
  &-popper.el-popover {
    --el-popover-padding: 0;
    min-width: 200px;
    width: auto!important;
    &.hide {
      display: none !important;
    }
    ul {
      padding-right: 20px;
    }
  }
  &-options {
    margin: 10px 0;
    padding: 0 5px 0 0;
    text-indent: 25px;
    line-height: 32px;
    max-height: 300px;
    overflow: auto;
    li {
      cursor: pointer;
      &.on, &:hover {
        color: #409EFF;
        background: #f5f7fa;
      }
    }
  }
}
</style>
